import baseApi from "@/api/baseApi";

export default {
  addOrUpdate(form) {
    return baseApi.post('/api-piglet/api/baby-piglet/price-formula/v1', form);
  },
  calclulate(pigletPrice, salaryOld) {
    return baseApi.get(`/api-piglet/api/baby-piglet/price-formula/calculate/${pigletPrice}/v1?salaryOld=${salaryOld}`);
  },
  fetch() {
    return baseApi.get('/api-piglet/api/baby-piglet/price-formula/v1');
  }
}
